import React from "react";

export default function Modal({ 
  isOpen, 
  title, 
  message, 
  type = "info", 
  onClose,
  onConfirm,           // 🔥 NUEVO: Función que se ejecuta al confirmar
  showCancel = false,  // 🔥 NUEVO: Para mostrar o no el botón de cancelar
  isLoading = false,   // 🔥 NUEVO: Estado de cargando
  confirmText = "Entendido",
  cancelText = "Cancelar"
}) {
  if (!isOpen) return null;

  // Configuración dinámica según el tipo de alerta
  const config = {
    success: { icon: "🎉", color: "#10B981" },
    warning: { icon: "⚠️", color: "#EAC024" },
    info:    { icon: "ℹ️", color: "#3B82F6" },
    error:   { icon: "❌", color: "#EF4444" },
    question:{ icon: "❓", color: "#6366F1" } // 🔥 NUEVO: Para confirmaciones
  };

  const { icon, color } = config[type] || config.info;

  return (
    <div style={styles.overlay}>
      {/* Estilos para animar el spinner de carga */}
      <style>
        {`
          @keyframes spin { 100% { transform: rotate(360deg); } }
          @keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        `}
      </style>
      <div style={styles.content}>
        <div style={{ fontSize: "32px", marginBottom: "10px" }}>{icon}</div>
        
        <h3 style={styles.title}>{title}</h3>
        <p style={styles.message}>{message}</p>
        
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          {/* BOTÓN DE CANCELAR */}
          {showCancel && (
            <button 
              onClick={onClose}
              disabled={isLoading} // Se bloquea si está cargando
              style={{ 
                ...styles.button, 
                backgroundColor: "#F3F4F6", 
                color: "#374151",
                cursor: isLoading ? "not-allowed" : "pointer",
                opacity: isLoading ? 0.6 : 1,
                flex: 1
              }}
            >
              {cancelText}
            </button>
          )}

          {/* BOTÓN DE ACCIÓN / CONFIRMAR */}
          <button 
            onClick={onConfirm || onClose}
            disabled={isLoading} // Se bloquea si está cargando
            style={{ 
              ...styles.button, 
              backgroundColor: color, 
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.7 : 1,
              display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
              flex: showCancel ? 1 : "none",
              minWidth: showCancel ? "auto" : "100%"
            }}
          >
            {isLoading ? (
              <>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ animation: "spin 1s linear infinite" }}>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" opacity="0.3"></circle>
                    <path d="M12 2a10 10 0 0 1 10 10" stroke="currentColor" strokeWidth="4" strokeLinecap="round"></path>
                </svg>
                Procesando...
              </>
            ) : (
              confirmText
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

// Estilos encapsulados del Modal
const styles = {
  overlay: {
    position: "fixed", top: 0, left: 0, width: "100%", height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(4px)", 
    display: "flex", justifyContent: "center", alignItems: "center", zIndex: 9999
  },
  content: {
    backgroundColor: "white", padding: "30px", borderRadius: "16px",
    width: "90%", maxWidth: "400px", textAlign: "center",
    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
    animation: "fadeIn 0.2s ease-out"
  },
  title: { margin: "0 0 8px 0", fontSize: "20px", fontWeight: "800", color: "#1F2937" },
  message: { margin: "0 0 20px 0", fontSize: "14px", color: "#6B7280", lineHeight: "1.5" },
  button: {
    padding: "10px 24px", borderRadius: "8px", border: "none",
    color: "white", fontWeight: "bold", fontSize: "14px", transition: "filter 0.2s"
  }
};